import TypeOfInstalation from "./SpoutLevel";

export default TypeOfInstalation;